import { Injectable, signal } from '@angular/core';
import { AuthUserInfoValue, IAuthService } from '@core-features/core';
import { Observable, of } from 'rxjs';

/**
 * AUTH_SERVICE implementation for public apps that have no user login
 * (e.g. the Solutions Configurator). The session is always unauthenticated and
 * there is no user info; login/logout/profile are no-ops. Provided via
 * `AuthModule.forPublic()`.
 */
@Injectable()
export class AuthPublicService implements IAuthService {
  readonly isAuthenticated$: Observable<boolean> = of(false);
  readonly $isAuthenticated = signal(false);
  readonly userInfo$: Observable<AuthUserInfoValue> = of(undefined);
  readonly $userInfo = signal<AuthUserInfoValue>(undefined);

  isAccessTokenValid(): boolean {
    return false;
  }

  getAccessToken(): Promise<string> {
    return Promise.resolve('');
  }

  login(): void {
    // no-op: a public app has no interactive login
  }

  logout(): void {
    // no-op: nothing to log out of
  }

  logoutLocally(): void {
    // no-op
  }

  navigateToProfile(): void {
    // no-op: no user profile in a public app
  }

  refreshUserInfo(): Observable<boolean> {
    return of(false);
  }
}
